// extracted by mini-css-extract-plugin
module.exports = {"iconStyle":"QrHubMessage_iconStyle__89ZO3"};